import { render, staticRenderFns } from "./EchartsPie.vue?vue&type=template&id=90c29040&"
import script from "./EchartsPie.vue?vue&type=script&lang=js&"
export * from "./EchartsPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports